module.exports = __webpack_public_path__ + "img/dashboard-main-desktop-ru.2f092731.jpg";